import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Skeleton from '@mui/material/Skeleton';
import Paper from '@mui/material/Paper';

import PhoneIcon from '@mui/icons-material/Phone';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import EmailIcon from '@mui/icons-material/Email';

import IconText from './../../../base/IconText';

import { CardContainer } from './CardContainer';

/**
 * Contact information card with original styling
 */
export default function ContactCard({ contact }) {
  if (
    !contact?.name &&
    !contact?.email &&
    !contact?.mobile &&
    !contact?.phone
  ) {
    return null;
  }

  return (
    <Grid id="contact-card" item container xs={12}>
      <CardContainer>
        <Grid item container xs={12}>
          {contact.name && (
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{
                  color: 'text.secondary',
                  mb: 1,
                }}
              >
                {contact.name}
              </Typography>
            </Grid>
          )}
          {contact.email && (
            <Grid item xs={12}>
              <IconText icon={EmailIcon}>
                <Link underline="none" href={`mailto:${contact.email}`}>
                  {contact.email}
                </Link>
              </IconText>
            </Grid>
          )}
          {contact.phone && (
            <Grid item xs={12}>
              <IconText icon={PhoneIcon}>
                <Link underline="none" href={`tel:${contact.phone}`}>
                  {contact.phone}
                </Link>
              </IconText>
            </Grid>
          )}
          {contact.mobile && (
            <Grid item xs={12}>
              <IconText icon={PhoneIphoneIcon}>
                <Link underline="none" href={`tel:${contact.mobile}`}>
                  {contact.mobile}
                </Link>
              </IconText>
            </Grid>
          )}
        </Grid>
      </CardContainer>
    </Grid>
  );
}

export function ContactCardSkeleton() {
  return (
    <Paper
      sx={{
        p: 2,
        border: '1px solid',
        borderRadius: (theme) => `${theme.shape.borderRadius}px`,
        borderColor: (theme) => theme.palette.divider,
      }}
    >
      <Skeleton variant="text" width="30%" height={24} />
      <Skeleton variant="text" width="60%" height={20} />
      <Skeleton variant="text" width="50%" height={20} />
    </Paper>
  );
}
